"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CANCELATION_REASONS = exports.EVICTION_STATUSES = void 0;
exports.EVICTION_STATUSES = {
    PENDING: 'pending',
    FILED: 'filed',
    COMPLETED: 'completed',
    CANCELED: 'canceled'
};
exports.CANCELATION_REASONS = {
    BALANCE_PAID: 'Balance Paid',
    TENANT_VACATED_PRIOR_TO_JUDGEMENT: 'Tenant Vacated Prior to Judgement',
    JUDGMENT_RECEIVED_TENANT_VACATED_PRIOR_TO_LOCKOUT: 'Judgment Received, Tenant Vacated Prior to Lockout',
    ACCIDENTAL_WRONG_PROPERTY: 'Accidental / Wrong Property',
    OTHER: 'Other'
};
